import React from 'react';
import { CheckCircleIcon, RefreshCwIcon, UserIcon, BellIcon, ShieldIcon, DatabaseIcon, ToggleLeftIcon, ToggleRightIcon } from 'lucide-react';
export const SettingsPage: React.FC = () => {
  return <main className="flex-1 overflow-y-auto bg-gray-50 p-6" data-id="element-557">
      <div className="mb-6" data-id="element-558">
        <h1 className="text-2xl font-bold mb-2" data-id="element-559">Settings</h1>
        <p className="text-gray-600" data-id="element-560">
          Manage your account, preferences, and system integrations.
        </p>
      </div>
      {/* EHR Integration Status */}
      <div className="bg-white rounded-lg shadow mb-6" data-id="element-561">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-562">
          <h2 className="text-lg font-medium" data-id="element-563">EHR System Integration</h2>
        </div>
        <div className="p-6" data-id="element-564">
          <div className="flex items-center justify-between" data-id="element-565">
            <div className="flex items-center" data-id="element-566">
              <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center mr-4" data-id="element-567">
                <CheckCircleIcon className="h-6 w-6 text-green-600" data-id="element-568" />
              </div>
              <div data-id="element-569">
                <h3 className="font-medium text-gray-900" data-id="element-570">
                  Connected to Eldermark EHR
                </h3>
                <p className="text-sm text-gray-500" data-id="element-571">
                  Last synced: Today at 9:45 AM
                </p>
              </div>
            </div>
            <button className="flex items-center px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-572">
              <RefreshCwIcon className="h-4 w-4 mr-2" data-id="element-573" />
              Test Connection
            </button>
          </div>
          <div className="mt-6 bg-blue-50 border border-blue-100 rounded-lg p-4" data-id="element-574">
            <div className="flex" data-id="element-575">
              <div className="flex-shrink-0" data-id="element-576">
                <DatabaseIcon className="h-5 w-5 text-blue-600" data-id="element-577" />
              </div>
              <div className="ml-3" data-id="element-578">
                <h3 className="text-sm font-medium text-blue-800" data-id="element-579">
                  Data Synchronization Active
                </h3>
                <div className="mt-2 text-sm text-blue-700" data-id="element-580">
                  <p data-id="element-581">
                    Further Insights is successfully receiving data from
                    Eldermark EHR. All resident information, care plans, and
                    medical records are up to date.
                  </p>
                </div>
                <div className="mt-4" data-id="element-582">
                  <div className="flex items-center" data-id="element-583">
                    <div className="w-full bg-blue-200 rounded-full h-2.5" data-id="element-584">
                      <div className="bg-blue-600 h-2.5 rounded-full" style={{
                      width: '100%'
                    }} data-id="element-585"></div>
                    </div>
                    <span className="ml-2 text-xs text-blue-700 font-medium" data-id="element-586">
                      100%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-587">
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-588">
              <div className="font-medium mb-1" data-id="element-589">Residents</div>
              <div className="text-2xl font-bold" data-id="element-590">247</div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-591">Records synced</div>
            </div>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-592">
              <div className="font-medium mb-1" data-id="element-593">Medications</div>
              <div className="text-2xl font-bold" data-id="element-594">1,358</div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-595">Records synced</div>
            </div>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-596">
              <div className="font-medium mb-1" data-id="element-597">Care Plans</div>
              <div className="text-2xl font-bold" data-id="element-598">247</div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-599">Records synced</div>
            </div>
          </div>
        </div>
      </div>
      {/* Other Settings Sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-600">
        {/* Account Settings */}
        <div className="bg-white rounded-lg shadow" data-id="element-601">
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-602">
            <h2 className="text-lg font-medium flex items-center" data-id="element-603">
              <UserIcon className="h-5 w-5 mr-2 text-gray-500" data-id="element-604" />
              Account Settings
            </h2>
          </div>
          <div className="p-6" data-id="element-605">
            <div className="space-y-4" data-id="element-606">
              <div data-id="element-607">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-608">
                  Email Address
                </label>
                <input type="email" value="admin@furthercare.com" readOnly className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50" data-id="element-609" />
              </div>
              <div data-id="element-610">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-611">
                  Facility
                </label>
                <input type="text" value="Lakeside Gardens Senior Living" readOnly className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50" data-id="element-612" />
              </div>
              <div data-id="element-613">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-614">
                  Role
                </label>
                <input type="text" value="Administrator" readOnly className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50" data-id="element-615" />
              </div>
              <button className="w-full mt-2 bg-[#1f58b0] text-white py-2 px-4 rounded-md hover:bg-[#255db7] transition-colors" data-id="element-616">
                Change Password
              </button>
            </div>
          </div>
        </div>
        {/* Notification Settings */}
        <div className="bg-white rounded-lg shadow" data-id="element-617">
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-618">
            <h2 className="text-lg font-medium flex items-center" data-id="element-619">
              <BellIcon className="h-5 w-5 mr-2 text-gray-500" data-id="element-620" />
              Notification Settings
            </h2>
          </div>
          <div className="p-6" data-id="element-621">
            <div className="space-y-4" data-id="element-622">
              <div className="flex items-center justify-between" data-id="element-623">
                <div data-id="element-624">
                  <h3 className="font-medium text-gray-900" data-id="element-625">
                    Email Notifications
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-626">
                    Receive daily reports and alerts via email
                  </p>
                </div>
                <ToggleRightIcon className="h-6 w-6 text-[#1f58b0]" data-id="element-627" />
              </div>
              <div className="flex items-center justify-between" data-id="element-628">
                <div data-id="element-629">
                  <h3 className="font-medium text-gray-900" data-id="element-630">Critical Alerts</h3>
                  <p className="text-sm text-gray-500" data-id="element-631">
                    Urgent notifications for high-priority events
                  </p>
                </div>
                <ToggleRightIcon className="h-6 w-6 text-[#1f58b0]" data-id="element-632" />
              </div>
              <div className="flex items-center justify-between" data-id="element-633">
                <div data-id="element-634">
                  <h3 className="font-medium text-gray-900" data-id="element-635">Weekly Summary</h3>
                  <p className="text-sm text-gray-500" data-id="element-636">
                    Receive weekly performance and analytics summary
                  </p>
                </div>
                <ToggleLeftIcon className="h-6 w-6 text-gray-400" data-id="element-637" />
              </div>
              <div className="flex items-center justify-between" data-id="element-638">
                <div data-id="element-639">
                  <h3 className="font-medium text-gray-900" data-id="element-640">System Updates</h3>
                  <p className="text-sm text-gray-500" data-id="element-641">
                    Notifications about system maintenance and updates
                  </p>
                </div>
                <ToggleRightIcon className="h-6 w-6 text-[#1f58b0]" data-id="element-642" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Security Section */}
      <div className="bg-white rounded-lg shadow mt-6" data-id="element-643">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-644">
          <h2 className="text-lg font-medium flex items-center" data-id="element-645">
            <ShieldIcon className="h-5 w-5 mr-2 text-gray-500" data-id="element-646" />
            Security & Privacy
          </h2>
        </div>
        <div className="p-6" data-id="element-647">
          <div className="mb-6" data-id="element-648">
            <h3 className="font-medium text-gray-900 mb-2" data-id="element-649">
              Two-Factor Authentication
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-650">
              Add an extra layer of security to your account
            </p>
            <button className="bg-[#1f58b0] text-white py-2 px-4 rounded-md hover:bg-[#255db7] transition-colors" data-id="element-651">
              Enable 2FA
            </button>
          </div>
          <div className="border-t border-gray-200 pt-6" data-id="element-652">
            <h3 className="font-medium text-gray-900 mb-2" data-id="element-653">
              Session Management
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-654">
              Your account is currently signed in on 1 device
            </p>
            <button className="border border-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-50 transition-colors" data-id="element-655">
              Sign Out All Devices
            </button>
          </div>
        </div>
      </div>
    </main>;
};